export class EventBus {
  constructor() {
    this.listeners = {};
    this.latestGameState = null;
  }

  on(event, callback) {
    if (!this.listeners[event]) {
      this.listeners[event] = [];
    }
    this.listeners[event].push(callback);
  }

  emit(event, data) {
    if (event === "gameState") {
      this.latestGameState = data;
    }
    if (this.listeners[event]) {
      this.listeners[event].forEach(callback => callback(data));
    }
  }

  removeListener(event, callback) {
    if (this.listeners[event]) {
      this.listeners[event] = this.listeners[event].filter(cb => cb !== callback);
    }
  }

  getLatestGameState() {
    return this.latestGameState;
  }
}

export const eventBus = new EventBus();
